.termsPage {
  .title,
  .subtitle {
    text-align: center;
    display: block;
  }

  .title {
    line-height: 125%;
  }

  .subtitle {
    margin: 1.25rem 0 1rem;
    line-height: 140%;
  }

  .block {
    max-width: 32rem;
    margin: 0 auto;
    padding: 3rem 0 0;

    @media (min-width: 769px) {
      max-width: 40rem;
    }

    @media (min-width: 1281px) {
      max-width: 55.5rem;
    }

    .blockTitle {
      margin-bottom: 1rem;
      line-height: 140%;
    }

    .blockText {
      padding-left: 1.5rem;
      list-style-type: square;

      .listItem {
        font-size: 1.25rem;

        @media (min-width: 1281px) {
          margin-top: 0.125rem;
          margin-bottom: 0.375rem;
        }
      }

      .blockTextSubtitle {
        margin-bottom: 0.75rem;
        margin-left: -1.5rem;
      }
    }
  }
}
